module.exports = __webpack_public_path__ + "img/punnet.24f23020.svg";